import React, { useState, useEffect, useRef } from 'react'
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AlertOnLoading from '../components/AlertOnLoading';
import Map from '../components/Map';
import AlertBox from '../components/AlertBox';
import ProductCard from '../components/ProductCard';
import { Toaster } from 'react-hot-toast';
import { collection, getDocs, query, orderBy, setDoc, doc } from "firebase/firestore"
import {database } from '../config/firebaseConfig';
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Pagination, Autoplay } from "swiper";
import Feedback from '../components/Feedback'
import {XMarkIcon} from '@heroicons/react/24/outline';

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "../styles/customSwiperHome.css";

//<Navbar />
function HomePage() {
  const SUCCESS = "success";
  const WARNING = "warning";

  const WAIT_TIME = 1000; //Waits for 2s
  const [newDataCampaigns, setNewDataCampaigns] = useState(true);
  const [newData, setNewData] = useState(true);
  const notInitialRender = useRef(false);

  const [activeCampaigns, setActiveCampaigns] = useState(null);

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [packages, setPackages] = useState(null);
  const [isOpenInquiry, setIsOpenInquiry] = useState(false);
  const [uploading, setUploading] = useState(false);

  const formatPrice = (value) => {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }

    /*
    Creates a new inquiry document on firebase
  */
    async function createInquiry() {
      const newsCollectionRef = collection(database, "inquiries");
      if (fullName === "") {
          AlertBox(WARNING, '¡Debe ingresar su nombre completo!');
          return;

      } else if (email === "") {
          AlertBox(WARNING, '¡Debe ingresar un correo electrónico!');
          return;

      } else if (phone === "") {
          AlertBox(WARNING, '¡Debe ingresar un número de teléfono!');
          return;
      } else if (message === "") {
        AlertBox(WARNING, '¡Debe ingresar un mensaje para la consulta!');
        return;
      } else {
          const addButton = document.querySelectorAll("#addRegister");
          console.log(addButton);
          addButton[0].setAttribute("disabled", true);

          setUploading(true);

          const newNewsRef = doc(newsCollectionRef);
          await setDoc(newNewsRef, {name: fullName, email:email, phone:phone, message:message});

          setFullName("");
          setEmail("");
          setMessage("");
          setPhone("");

          addButton[0].removeAttribute("disabled");

          setUploading(false);
          
          AlertBox(SUCCESS, 'Consulta realizada exitosamente');
          return;
      }
  }

    /*
        Gets all active campaigns 
    */
    useEffect(() => {
      if (newDataCampaigns) {
          const activeCampaignsRef = collection(database, "activeCampaigns");
          const getActiveCampaigns = async() => {
              const campaignQuery = query(activeCampaignsRef, orderBy("position"));
              const data = await getDocs(campaignQuery);
              setActiveCampaigns(data.docs.map((doc, index) => ({...doc.data(), id: index+1, index:doc.id})));
          }
          
          const interval = setInterval(() => { //Autorize re-render
              getActiveCampaigns();
              setNewDataCampaigns(!newDataCampaigns);
          }, WAIT_TIME);
          return () => clearInterval(interval);
      }
  }, [activeCampaigns, newDataCampaigns])

  /*
    Gets packages and tests
  */
  useEffect(() => {
    if (notInitialRender.current && newData){
        AlertOnLoading(WAIT_TIME+100);
    }else {
        notInitialRender.current = true;
    } 
    const interval = setInterval(() => { //Autorize re-render
        if (newData) {
            const PackagesRef = collection(database, "paquetes");
            const getPackages = async() => {
              const data = await getDocs(PackagesRef);
              setPackages(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
            }

            console.log("Actualizo");
            getPackages();
            setNewData(!newData);
        }
    }, WAIT_TIME);
    return () => clearInterval(interval);
  }, [packages, newData])

  return (
    <div>
        
        <div>
          <Toaster
          toastOptions={{
              duration:3000,
          }}/>
        </div>
        
        <Navbar activePage={"/"} />
        <div className='w-full h-navbar-mobile sm:h-navbar'></div>
        <div className='w-full h-auto bg-white'>
          
          <Swiper
            pagination={{
              clickable: true,
              type: "progressbar"
            }}
            effect={"fade"}
            autoplay={{
              delay: 6500,
              disableOnInteraction: false,
            }}
            modules={[EffectFade, Pagination, Autoplay]}
            className="SwiperHome h-60 md:h-auto"
          >
            {activeCampaigns? activeCampaigns.map((campaign) => (
              <SwiperSlide key={campaign.id} className='flex justify-center bg-white'>
                <img src={campaign.image} alt="Slider" className='swiper-lazy w-full h-full'></img>
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </SwiperSlide>
            ))

            :
            
            <SwiperSlide key={0} className='flex justify-center bg-white'>
              <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                    <path clipRule='evenodd'
                        d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                        fill='currentColor' fillRule='evenodd' />
                </svg>
                <div>
                    Cargando...
                </div>
              </div>
            </SwiperSlide>
            }
          </Swiper>

        </div>

        <div className='w-full h-full bg-white my-6'>
          <div className='px-4 py-6 flex flex-col w-full h-0 bg-white lg:py-8'>
            <h2 className='lg:text-xl'>Paquetes destacados</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>
          </div>
            
          {<div className={`${packages? "py-10 px-4 w-full h-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 form1:grid-cols-5 gap-8 justify-items-center pb-6 sm:pb-4" : "flex w-full"} `}>
          {
            packages? packages.slice(0, 5).map((packet, index) => (
              <div key={packet.id}>
                <ProductCard
                  id={packet.id} 
                  image={packet.imagen} 
                  title={packet.nombre} 
                  description={packet.descripcion}
                  price={formatPrice(packet.precio)}
                  action={setIsOpenInquiry}/>
              </div>
            ))
            
            :

            <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                    <path clipRule='evenodd'
                        d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                        fill='currentColor' fillRule='evenodd' />
                </svg>
                <div>
                    Cargando...
                </div>
            </div>
          }
          </div>}


        </div>

        {<Feedback /> }

        <div className='w-full h-full bg-white my-6 mb-6'>

          <div className='px-4 py-6 flex flex-col w-full h-0 bg-white lg:py-8'>
            <h2 className='lg:text-xl'>Ubicación</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>
          </div>
          
          <div className='w-full h-full px-4 py-4 flex flex-row justify-evenly items-center md:space-x-10'>
            
            <div className='md:max-w-2xl w-full h-full flex flex-col justify-center items-center space-y-5'>

              <div className='md:max-w-2xl max-w-sm w-full h-footer-height rounded-lg overflow-hidden'>
                <Map selectedPlace={{lat: 10.036257789840104, lon: -84.1573615377943, address: {county: "Laboratorio Santa Bárbara"}}} scrollToZoom={false}/>
              </div>
              
              <div className='lg:hidden max-w-sm h-full bg-profilebox rounded-lg flex flex-col justify-center items-center text-center space-y-4'>
                
                <h2 className='text-about-blue text-xl pt-2'>Horarios de Atención</h2>
                
                <p className='lg:text-xl px-2'>Lunes a Viernes: 7:00am a 4:30pm</p>
                
                <p className='lg:text-xl px-2'>Sábados: 7:00am a 12:00pm</p>
                
                <h2 className='text-about-blue text-xl pt-2'>Dirección</h2>
                
                <p className='lg:text-xl px-2'>Laboratorio Clínico Santa Bárbara</p>
                
                <p className='lg:text-xl px-2'>De la esquina sureste de la Iglesia Católica 125m al sur</p>
                
                <p className='lg:text-xl px-2'>Santa Bárbara, Heredia, Costa Rica</p>
                
                <div className='w-full flex flex-row items-center justify-center space-x-1'>

                  <div className='w-full flex items-center justify-center bg-primary-100 rounded-bl-lg hover:bg-primary-200'>
                      <img className='w-14 h-14' src='/images/icons8-waze.svg' alt='WazeIcon'></img>
                      <a className='text-white text-lg font-bold px-2' href='https://www.waze.com/en/live-map/directions?latlng=10.035922070086505%2C-84.15751576423646'>WAZE</a>

                  </div>

                  <div className='w-full flex items-center justify-center bg-primary-100 rounded-br-lg hover:bg-primary-200'>
                    <img className='w-14 h-14' src='/images/icons8-google-maps-old.svg' alt='GoogleMapsIcon'></img>
                    <a className='text-white text-base font-bold px-2' href='https://goo.gl/maps/dENSNHnEZxukADZ97'>GOOGLE MAPS</a>
                  </div>
                  
                </div>
                
              </div>
              
            </div>

            <div className='hidden relative lg:max-w-md lg:h-footer-height lg:bg-profilebox lg:rounded-lg lg:flex lg:flex-col lg:justify-start lg:items-center lg:text-center lg:space-y-4 pt-5'>
                
                <h2 className='text-about-blue text-xl pt-2'>Horarios de Atención</h2>
                
                <p className='text-xl px-2'>Lunes a Viernes: 7:00am a 4:30pm</p>
                
                <p className='text-xl px-2'>Sábados: 7:00am a 12:00pm</p>
                
                <h2 className='text-about-blue text-xl pt-2'>Dirección</h2>
                
                <p className='text-xl px-2'>Laboratorio Clínico Santa Bárbara</p>
                
                <p className='text-xl px-2'>De la esquina sureste de la Iglesia Católica 125m al sur</p>
                
                <p className='text-xl px-2'>Santa Bárbara, Heredia, Costa Rica</p>
                
                <div className='w-full h-12 flex flex-row items-end justify-center space-x-1 absolute bottom-0'>

                  <a href='https://www.waze.com/en/live-map/directions?latlng=10.035922070086505%2C-84.15751576423646' className='w-full flex items-center justify-center bg-primary-100 rounded-bl-lg hover:bg-primary-200'>
                    <img className='w-14 h-14' src='/images/icons8-waze.svg' alt='WazeIcon'></img>
                    <p className='text-white text-lg font-bold px-2'>WAZE</p>
                  </a>

                  <a href='https://goo.gl/maps/dENSNHnEZxukADZ97' className='w-full flex items-center justify-center bg-primary-100 rounded-br-lg hover:bg-primary-200'>
                    <img className='w-14 h-14' src='/images/icons8-google-maps-old.svg' alt='GoogleMapsIcon'></img>
                    <p className='text-white text-base font-bold px-2'>GOOGLE MAPS</p>
                  </a>
                  
                </div>
                
              </div>
            
            </div>

        </div>

        <div className='w-full h-full bg-white my-6'>
          <div className='px-4 py-6 flex flex-col w-full h-0 bg-white lg:py-8'>
            <h2 className='lg:text-xl'>Contacto</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>
          </div>

          <div className='w-full h-auto px-4 py-4 flex flex-row justify-evenly items-center'>

            <div className='w-full lg:w-auto lg:space-y-0 h-full flex flex-col justify-center items-center space-y-5'>
              
              <div className='max-w-sm w-full h-96 lg:w-screen lg:h-screen max-h-[482px] bg-profilebox rounded-lg flex flex-col text-center justify-between'>

                <div className='w-full h-12 rounded-t-lg bg-primary-100 px-3'>
                  <h2 className='text-white text-xl pt-2'>Laboratorio Santa Bárbara</h2>
                </div>

                <a href='tel:22699990' className='flex flex-row w-full items-center justify-start pl-5 pr-5 space-x-5'>
                  <img className='w-14 h-14' src='/images/icons8-ringing-phone-100.svg' alt='PhoneIcon'></img>
                  <p  className='text-black text-xl pt-2'>(+506) 2269-9990</p>
                </a>

                <a href='mailto:labstabarbara@gmail.com' className='flex flex-row w-full items-center justify-start pl-5 pr-2 space-x-5'>
                  <img className='w-14 h-14' src='/images/icons8-mail-60.svg' alt='MessageIcon'></img>
                  <p className='text-black text-xl pt-2'>labstabarbara@gmail.com</p>
                </a>
                
                <div className='w-full flex flex-row items-center justify-center space-x-1'>

                  <a href='tel:22699990' className='w-full h-full flex items-center justify-center bg-primary-100 hover:bg-primary-200 rounded-bl-lg'>
                      <img className='w-14 h-14' src='/images/icons8-call-64.svg' alt='PhoneIcon'></img>
                      <p className='text-white text-base font-bold px-2'>LLAMAR</p>
                  </a>

                  <a href='https://wa.link/dnhyck' className='w-full h-full flex items-center justify-center bg-primary-100 hover:bg-primary-200 rounded-br-lg'>
                    <img className='w-12 h-12' src='/images/whatsapp.svg' alt='MessageIcon'></img>
                    <p className='text-white text-base font-bold px-2'>MENSAJE</p>
                  </a>
                  
                </div>

              </div>

              <div className='lg:hidden max-w-sm w-full h-auto bg-white border border-primary-100 rounded-lg flex flex-col justify-center items-center text-center space-y-5'>

                <h2 className='text-black text-xl pt-2'>Contacto en línea</h2>

                <div className='w-full h-full py-5 px-5 flex flex-col space-y-3'>

                  <input type={"text"} placeholder="Nombre Completo" onChange={(ev) => {setFullName(ev.target.value)}} value={fullName}
                  className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
                  focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>

                  <input type={"text"} placeholder="Correo Electrónico" onChange={(ev) => {setEmail(ev.target.value)}} value={email}
                    className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>

                  <input type={"text"} placeholder="Teléfono" onChange={(ev) => {setPhone(ev.target.value)}} value={phone}
                    className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                  
                  <textarea className={`md:text-base mt-6 sm:mt-4 py-2 px-4 h-36 w-full text-sm text-input-font bg-primary-300
                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none`}
                    onChange={(ev) => {setMessage(ev.target.value)}} value={message}
                    id="description" name="description" rows="7" cols="41" placeholder='Mensaje'></textarea>

                </div>

                <div>
                <button className='mb-2 w-32 h-8 text-sm bg-primary-100 text-white rounded font-bold form1:text-xl hover:bg-primary-200'
                        onClick={createInquiry}
                      >Enviar</button>
                </div>


              </div>


            </div>
            
            <div className='hidden lg:max-w-sm lg:w-full lg:h-full max-h-[500px] lg:bg-white lg:border lg:border-primary-100 lg:rounded-lg lg:flex lg:flex-col lg:justify-center lg:items-center lg:text-center lg:space-y-5'>

              <h2 className='text-black text-xl pt-2'>Contacto en línea</h2>

              <div className='w-full h-full py-5 px-5 flex flex-col space-y-3'>

                <input type={"text"} placeholder="Nombre Completo" onChange={(ev) => {setFullName(ev.target.value)}} value={fullName}
                className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
                focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>

                <input type={"text"} placeholder="Correo Electrónico" onChange={(ev) => {setEmail(ev.target.value)}} value={email}
                  className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
                  focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>

                <input type={"text"} placeholder="Teléfono" onChange={(ev) => {setPhone(ev.target.value)}} value={phone}
                  className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
                  focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                
                <textarea className={`md:text-base mt-6 sm:mt-4 py-2 px-4 h-36 w-full text-sm text-input-font bg-primary-300
                  focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none`}
                  onChange={(ev) => {setMessage(ev.target.value)}} value={message}
                  id="description" name="description" rows="7" cols="41" placeholder='Mensaje'></textarea>

              </div>
              
              <div>
              <button className='mb-2 w-32 h-8 text-sm bg-primary-100 text-white rounded font-bold form1:text-xl hover:bg-primary-200'
                      onClick={createInquiry}
                    >Enviar</button>
              </div>


            </div>

          </div>


        </div>
        
        <div className={`${isOpenInquiry? "flex": "hidden"} h-screen w-screen fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-50 items-center justify-center px-4 sm:px-10`}> 
          <div className='relative md:max-w-2xl max-w-md w-full flex flex-col justify-center items-center mx-10 sm:mx-5 h-auto bg-white rounded-2xl max-h-popup-mobile py-10'>
            <button onClick={() => {setIsOpenInquiry(!isOpenInquiry)}}
              className='absolute top-1 right-1 hover:text-primary-100 bg-white md:bg-transparent rounded-full'><XMarkIcon className='w-8 h-8 md:w-12 md:h-12'/></button>
            <div className='text-2xl font-medium'>
              Contacto en Línea
            </div>
            
            <div className='w-full h-4/5 py-10 px-10 md:px-20 flex flex-col space-y-6'>
              <input type={"text"} placeholder="Nombre Completo" onChange={(ev) => {setFullName(ev.target.value)}} value={fullName}
                className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
                focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>

              <input type={"text"} placeholder="Correo Electrónico" onChange={(ev) => {setEmail(ev.target.value)}} value={email}
                className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
                focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>

              <input type={"text"} placeholder="Teléfono" onChange={(ev) => {setPhone(ev.target.value)}} value={phone}
                className='md:text-base text-sm w-full h-12 py-2 px-4 text-input-font bg-primary-300
                focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
              
              <textarea className={`md:text-base mt-6 sm:mt-4 py-2 px-4 h-36 w-full text-sm text-input-font bg-primary-300
                focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none`}
                onChange={(ev) => {setMessage(ev.target.value)}} value={message}
                id="description" name="description" rows="7" cols="41" placeholder='Mensaje'></textarea>
            </div>

            <button id="addRegister" onClick={createInquiry}
              className='w-1/2 py-2 text-white font-semibold bg-primary-100 rounded-md text-lg hover:bg-primary-200 cursor-pointer ease-in-out absolute -bottom-5 disabled:bg-primary-200'>
                {!uploading? 
                "Enviar"
                : 
                <div className="w-full flex justify-center items-center"> 
                    <svg fill='none' className="w-8 h-8 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                    <path clipRule='evenodd'
                        d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                        fill='currentColor' fillRule='evenodd' />
                    </svg> 
                    Enviando
                </div>}
            </button>
          </div>
        </div>

        <Footer />
    </div>
  )
}

export default HomePage

